<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="省份">
                <a-select
                  v-model="queryParam.provinceCode"
                  placeholder="请选择省份"
                  allow-clear
                >
                  <a-select-option
                    v-for="item in provinceList"
                    :value="item.code"
                    :key="item.code"
                  >
                    {{ item.descript }}({{ item.code }})
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="城市名称"
                ><a-input v-model="queryParam.descript" placeholder="城市名称"
              /></a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="城市代码"
                  ><a-input v-model="queryParam.code" placeholder="城市代码"
                /></a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button
                  class="button-margin-left"
                  @click="() => (queryParam = {})"
                  >重置</a-button
                >

                <a-button
                  type="primary"
                  icon="plus"
                  @click="showModal('add')"
                  v-hasAnyPermission="`city:add`"
                  class="button-margin-left"
                  >新建</a-button
                >

                <a @click="toggleAdvanced" class="button-margin-left">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
      >
        <span slot="tagItem" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag
              class="render-tag"
              color="#2db7f5"
              v-if="record.isCapital == 'T'"
              >首都</a-tag
            >
            <a-tag
              class="render-tag"
              color="#87d068"
              v-if="record.isProvinceCapital == 'T'"
              >省会</a-tag
            >
            <a-tag
              class="render-tag"
              color="#f50"
              v-if="record.isCityHot == 'T'"
              >热门</a-tag
            >
            <a-tag
              class="render-tag"
              color="#108ee9"
              v-if="record.isOpen == 'T'"
              >开通运营</a-tag
            >
            <a-tag class="render-tag" color="grey" v-if="record.isHalt == 'T'"
              >已停用</a-tag
            >
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              @click="action(record, 'edit')"
              v-hasAnyPermission="`city:edit`"
              >编辑</a
            >

            <a-popover
              v-model="record.district"
              :overlayStyle="{ maxWidth: '400px' }"
              title=""
              trigger="click"
              arrow-point-at-center
            >
              <template slot="content" @click="record.district = false">
                <a-tag
                  v-for="(item, idx) in popover.district"
                  :key="idx"
                  style="border-radius: 3px;color:#108ee9;border-color: #108ee9;margin: 5px;"
                  color="#ffffff"
                  >{{ item.descript }}({{ item.code }})</a-tag
                >
                <!-- <a style="margin: 5px;" @click="addAction(record, 'district')"
                  ><a-icon type="plus-circle" />添加区域</a
                > -->
              </template>
              <a class="a-action" @click="action(record, 'district')"
                >查看区域</a
              >
            </a-popover>

            <!-- <a-popover v-model="record.circle" title="" trigger="click">
              <template slot="content" @click="record.circle = false">
                <a-tag
                  v-for="(item, idx) in popover.circle"
                  :key="idx"
                  style="border-radius: 3px;color:#108ee9;border-color: #108ee9;margin: 5px;"
                  color="#ffffff"
                  >{{ item.descript }}({{ item.code }})</a-tag
                >
                <a style="margin: 5px;"
                  ><a-icon type="plus-circle" />添加商圈</a
                >
              </template>
              <a class="a-action" @click="action(record, 'circle')">商圈</a>
            </a-popover> -->
          </template>
        </span>
      </s-table>
    </a-card>
    <city-info
      ref="cityModal"
      :provinceList="provinceList"
      @success="$refs.table.refresh(true)"
    ></city-info>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";
import CityInfo from "./CityInfo.vue";

export default {
  name: "CityList",
  components: {
    STable,
    PageView,
    CityInfo
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 省份
      provinceList: [],
      // 表头
      columns: [
        {
          title: "城市代码",
          dataIndex: "code"
        },
        {
          title: "城市名称",
          dataIndex: "descript",
          scopedSlots: { customRender: "tagItem" }
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime",
          sorter: true
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.systemBksApi
          .pageCodeCity(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      },
      popover: {
        district: [],
        circle: []
      }
    };
  },
  created() {
    this.getProvince();
  },
  methods: {
    showModal(type) {
      let param = {};
      param.visible = true;
      param.title = type == "add" ? "添加城市" : "编辑城市";
      param.type = type;
      this.$refs.cityModal.show(param);
    },
    /**
     * 操作
     * @param {Object} record
     * @param {Object} type
     */
    action(record, type) {
      if (type == "edit") {
        this.$refs.cityModal.formData = Object.assign({}, record);
        this.showModal(type);
      } else if (type == "district") {
        this.$http.systemBksApi
          .findCodeDistrictByCityCode({ cityCode: record.code })
          .then(res => {
            this.popover.district = res.resultObject;
          });
      } else if (type == "circle") {
        console.log("circle");
        this.$http.systemBksApi
          .findCodeCircleByCityCode({ cityCode: record.code })
          .then(res => {
            this.popover.circle = res.resultObject;
          });
      }
    },
    addAction(record, type) {
      record[type] = false;
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    getProvince() {
      this.$http.systemBksApi
        .findProvinceCityDistrictCircleHelpCode({ isProvince: "T" })
        .then(res => {
          this.provinceList = res.resultObject.provinceList;
        });
    }
  }
};
</script>
<style lang="less"></style>
